import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {
  setHasTableProfilesStorage,
  getParsedHashtableProfiles,
} from "../disabledProfile";

import {
  setCurrentVideo,
  getCurrentVideo,
  setSelectedScenario,
  getCurrentScenario,
} from "../screensaverVideo";

type AcceptedProfiles = "ABIGAIL" | "JEREMY" | "MARK";

type HashtableProfiles = {
  profile: AcceptedProfiles;
  isDisabled: boolean;
};

interface DebuggerGUIProps {
  showDebugger: boolean;
  setShowDebugger: (any: boolean) => void;
  hashTableProfiles: boolean;
  setHashTableProfiles: (profile: string, disable: boolean) => void;
}

const DebuggerGUI: React.FC<DebuggerGUIProps> = ({
  showDebugger,
  setShowDebugger,
  hashTableProfiles,
  setHashTableProfiles,
}) => {
  const [hashDisabled, setHashDisabled] = useState<HashtableProfiles[]>(
    getParsedHashtableProfiles()
  );
  const [selectedProfile, setSelectedProfile] = useState<string>("JEREMY");
  const [selectedScenario, setScenario] = useState<string>(
    getCurrentScenario() || "SCENARIO 1 - V+O,V+I,V+A,V+R"
  );
  const [runExperience, setRunExperience] = useState<boolean>(true);

  const [updateInfo, setupdateInfo] = useState(false);

  const navigate = useNavigate();

  const requestFullscreen = () => {
    const el = document.documentElement;

    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if ((el as any).webkitRequestFullscreen) {
      (el as any).webkitRequestFullscreen();
    } else if ((el as any).mozRequestFullScreen) {
      (el as any).mozRequestFullScreen();
    } else if ((el as any).msRequestFullscreen) {
      (el as any).msRequestFullscreen();
    }
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
  };

  const isFullscreen = () =>
    !!(
      document.fullscreenElement ||
      (document as any).webkitFullscreenElement ||
      (document as any).mozFullScreenElement ||
      (document as any).msFullscreenElement
    );

  useEffect(() => {
    setHashDisabled(getParsedHashtableProfiles());
  }, [updateInfo]);

  useEffect(() => {
    let myScenario = getCurrentScenario();
    setSelectedScenario(myScenario as string);
    document
      .querySelector("#scenario-select")
      ?.setAttribute("value", myScenario as string);
  }, []);

  useEffect(() => {
    let myVideo = getCurrentVideo();

    if (myVideo === "screensaver2.mp4") navigate("/");
  }, []);

  const clearServiceWorkerCache = () => {
    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: "CLEAR_CACHE" });
    }
  };

  return (
    <div
      id="debugger"
      className={`${
        showDebugger ? "block" : "hidden"
      } absolute top-0 right-0 bg-white w-1/3 p-4 pr-12 z-50 flex flex-col justify-center items-center rounded-md text-left select-none`}
    >
      <div className="flex justify-center items-center w-full mb-2">
        <p className="text-md font-avenir mr-4 flex">
          Current:{" "}
          {selectedScenario != "null"
            ? selectedScenario
            : "SCENARIO 1 - V+O,V+I,V+A,V+R"}
        </p>

        <div className="absolute right-4 bg-slate-100 flex justify-center items-center w-8 h-8" onClick={() => {setShowDebugger(false);}}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            className="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
          </svg>
        </div>
        
      </div>
      <div className="flex justify-center items-center w-full">
        <select
          id="scenario-select"
          onChange={(e) => {
            const select = e.target as HTMLSelectElement;
            const selectedOption = select.options[select.selectedIndex];
            const selectedVideoEvent = select.value;

            setSelectedScenario(selectedOption.text);
            setScenario(selectedOption.text);

            const runExperienceAttr = selectedOption.getAttribute(
              "data-run-experience"
            );
            const runExperience = runExperienceAttr === "true";

            setRunExperience(runExperience);
            return setCurrentVideo(selectedVideoEvent, runExperience);
          }}
          className="bg-gray-200 p-2 mr-4 rounded-md w-full outline-none user-select-none"
        >
          <option value="" disabled selected defaultValue="">
            Select your option
          </option>
          <option
            defaultValue="screensaver1.mp4"
            value="screensaver1.mp4"
            data-run-experience={true}
          >
            SCENARIO 1 - V+O,V+I,V+A,V+R
          </option>
          <option
            defaultValue="screensaver2.mp4"
            value="screensaver2.mp4"
            data-run-experience={false}
          >
            SCENARIO 2 - V+R and V+O
          </option>
        </select>
      </div>

      <div className="flex justify-center items-center w-full mb-2">
        <button
          className="btn bg-cyan-700 text-white px-4 py-2 rounded-full w-1/2 my-2 mt-4 "
          onClick={async () => {
            try {
              clearServiceWorkerCache();
              setTimeout(() => {
                window.location.reload();
              }, 500);
            } catch (error) {
              console.log("error", error);
            }
          }}
        >
          Save and Reload
        </button>

        <div
          className="p-4 rounded-md absolute flex justify-end ml-4 right-16 bg-slate-100"
          onClick={async () => {
            isFullscreen() ? exitFullscreen() : requestFullscreen();
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrows-fullscreen" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"/>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default DebuggerGUI;
